import React, { PureComponent } from "react";

import styles from "./Preview.local.scss";
import _ from "i18n";
import { TTP_PORTAL_URL } from "Config";

export default class PelletComponent extends PureComponent {
  render() {
    const { hubPreferences } = this.props;

    if (!hubPreferences || hubPreferences.length == 0) {
      return (
        <div className={styles.preview}>
          <span>{_("No think to display!")}</span>
        </div>
      );
    }

    return (
      <div className={styles.preview}>
        <span>{_("Loading...")}</span>
        <iframe src={TTP_PORTAL_URL} id="previewIframe" />
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Preview/PreviewComponent.js